import { ReactNode } from 'react';

interface IconButtonProps {
  icon: ReactNode;
  onClick: () => void;
  disabled: boolean;
  title: string;
  danger?: boolean;
}

export function IconButton({ icon, onClick, disabled, title, danger }: IconButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: '0.75rem',
        background: 'transparent',
        color: danger ? '#8E0B56' : '#00303c',
        border: `2px solid ${danger ? '#fecaca' : '#e5e7eb'}`,
        borderRadius: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease',
      }}
      title={title}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.background = danger ? '#fee2e2' : '#f3f4f6';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
      }}
    >
      {icon}
    </button>
  );
}
